import { CHUNK_WIDTH, CHUNK_DEPTH } from '@shared/chunk-constants';

export function chunkKey(cx: number, cz: number): string {
  return `${cx},${cz}`;
}

export function parseChunkKey(key: string): [number, number] {
  const parts = key.split(',');
  return [parseInt(parts[0]), parseInt(parts[1])];
}

export function worldToChunkCoord(wx: number, wz: number): [number, number] {
  return [Math.floor(wx / CHUNK_WIDTH), Math.floor(wz / CHUNK_DEPTH)];
}

export function worldToLocalCoord(wx: number, wz: number): [number, number] {
  return [
    ((wx % CHUNK_WIDTH) + CHUNK_WIDTH) % CHUNK_WIDTH,
    ((wz % CHUNK_DEPTH) + CHUNK_DEPTH) % CHUNK_DEPTH,
  ];
}

export function chunkToWorldCoord(cx: number, cz: number): [number, number] {
  return [cx * CHUNK_WIDTH, cz * CHUNK_DEPTH];
}
